module.exports = __webpack_public_path__ + "img/plus-square.3fb7696e.svg";